import { render } from "./ContactusFaq.vue?vue&type=template&id=6bfe8425&scoped=true"
import script from "./ContactusFaq.vue?vue&type=script&lang=js"
export * from "./ContactusFaq.vue?vue&type=script&lang=js"

import "./ContactusFaq.vue?vue&type=style&index=0&id=6bfe8425&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfe8425"]])

export default __exports__